import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeService } from '../services/theme';
import { themeAsset } from '../services/theme-asset';
import { PriceScalePipe } from '../pipes/price-scale.pipe';
import { PercentageChangePipe } from '../pipes/percentage-change-pipe';

@Component({
  selector: 'app-v3-stock-header',
  templateUrl: './v3-stock-header.html',
  styleUrl: './v3-stock-header.scss',
  standalone: true,
  imports: [PriceScalePipe, PercentageChangePipe],
})
export class V3StockHeader {
  @Input() stockName = '';
  @Input() stockLogo!: string | null;
  @Input() price!: number | null;
  @Input() prevPrice!: number | null;
  // Mirrors V2's nav-bar `showCompanyLink` (core.html: `[showCompanyLink]="!!companyAnalysis()"`)
  // — false when there's no company/general analysis to navigate to, so this control doesn't
  // send the user to an empty "Unternehmensprofil" sub-page with no way back via tabs (V3's
  // tab nav deliberately excludes 'action' — see v3-root/CLAUDE.md).
  @Input() companyAvailable = true;
  @Output() companyClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  readonly companyIconSrc = themeAsset(this.themeService, 'company', 'png');
  readonly closeIconSrc = themeAsset(this.themeService, 'close');
}
